<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  action: { type: String, default: '' },
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);
const { t } = useI18n();
</script>

<template>
  <div
    v-if="show"
    role="alert"
    data-test="sales-party-internal-profile-alert"
    class="flex w-full items-start gap-3 rounded-lais-sm border border-lais-warning/40 bg-lais-warning/10 px-4 py-3 text-sm text-lais-text"
  >
    <span
      class="i-lucide-circle-alert mt-0.5 size-5 shrink-0 text-lais-warning"
      aria-hidden="true"
    />
    <p class="min-w-0 flex-1 leading-5">
      {{ t('SALES_PARTIES.PERSONAL.INTERNAL_PROFILE_ALERT_PREFIX') }}
      <strong>{{ action }}</strong>
      {{ t('SALES_PARTIES.PERSONAL.INTERNAL_PROFILE_ALERT_SUFFIX') }}
    </p>
    <button
      type="button"
      :aria-label="t('SALES_PARTIES.COMMON.CLOSE_NOTICE')"
      class="i-lucide-x size-5 shrink-0 text-lais-text-muted outline-none hover:text-lais-text focus-visible:ring-2 focus-visible:ring-lais-warning"
      @click="emit('close')"
    />
  </div>
  <span v-else class="hidden" aria-hidden="true" />
</template>
